export enum AttachmentTypes {
  PDF = 'application/pdf',
}
